import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import useLanguages from 'components/Common/Languages/Hooks/useLanguages';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Managers/Profile/Actions';

const transformValues = (values) => ({
  language_ids: values.languages,
});

export default function Languages({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const manager = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
  });

  const { languages } = useLanguages();

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      manager.id,
      transformValues(values),
      false,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        languages: manager.language_ids.map((el) => el.toString()),
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col>
              <HorizontalSelectField
                name="languages"
                label="Languages"
                isMulti
                placeholder={languages === null ? 'Loading...' : 'Select Languages'}
                options={languages === null ? [] : languages.map((el) => ({
                  label: el.attributes.title,
                  value: el.id,
                }))}
              />
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

Languages.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
